const _excluded = ["hooks", "collections", "provider"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { fromJS } from 'immutable';
import { CONFIG_SUCCESS } from '../actions/config';
export function getIntegrations(config) {
  const integrations = config.integrations || [];
  const newState = integrations.reduce((acc, integration) => {
    const {
        hooks,
        collections,
        provider
      } = integration,
      providerData = _objectWithoutProperties(integration, _excluded);
    acc.providers[provider] = _objectSpread({}, providerData);
    if (!collections) {
      hooks.forEach(hook => {
        acc.hooks[hook] = provider;
      });
      return acc;
    }
    const integrationCollections = collections === '*' ? config.collections.map(collection => collection.name) : collections;
    integrationCollections.forEach(collection => {
      hooks.forEach(hook => {
        acc.hooks[collection] ? acc.hooks[collection][hook] = provider : acc.hooks[collection] = {
          [hook]: provider
        };
      });
    });
    return acc;
  }, {
    providers: {},
    hooks: {}
  });
  return fromJS(newState);
}
const defaultState = fromJS({
  providers: {},
  hooks: {}
});
function integrations(state = defaultState, action) {
  switch (action.type) {
    case CONFIG_SUCCESS:
      {
        return getIntegrations(action.payload);
      }
    default:
      return state;
  }
}
export function selectIntegration(state, collection, hook) {
  return collection ? state.getIn(['hooks', collection, hook], false) : state.getIn(['hooks', hook], false);
}
export default integrations;